module.exports = __webpack_public_path__ + "static/twinkleplaque-bb83ae345ea7eea857d9ff7bebe8c779.png";